import API from './api';

const api = new API();

const URL_BOOKMARKS = '/api/bookmarks';
const URL_RECORD_BOOKMARK_OPEN = 'api/record_bookmark_open'; // no leading slash, matches legacy BookmarksService
const URL_BOOKMARK = '/api/bookmark';
const URL_GENERAL_AUDIT = '/api/audit/general';
const URL_LOGOUT = '/logout';
const URL_LANGUAGE = '/api/language';

class TopbarService {
    // These endpoints encode failures in an HTTP 200 response. forceRefresh also bypasses reads from the API cache.
    getBookmarks() {
        return api
            .getJson(URL_BOOKMARKS, {
                method: 'GET',
                credentials: 'include',
                cache: false,
                forceRefresh: true,
                legacyStatus: true,
            })
            .then(response => response.value);
    }

    recordBookmarkOpen(uuid, creator) {
        return api.getJson(URL_RECORD_BOOKMARK_OPEN, {
            method: 'POST',
            credentials: 'include',
            body: { uuid, creator },
            cache: false,
            legacyStatus: true,
        });
    }

    deleteBookmark(uuid) {
        return api.getJson(`${URL_BOOKMARK}/${uuid}`, {
            method: 'DELETE',
            credentials: 'include',
            cache: false,
            legacyStatus: true,
        });
    }

    // Do not mark this request unique: report-page saves use the same cancellation key.
    saveBookmark(payload) {
        return api
            .getJson(URL_BOOKMARK, {
                method: 'POST',
                credentials: 'include',
                body: payload,
                cache: false,
                addBrowserLocation: false,
                legacyStatus: true,
            })
            .then(response => response.value);
    }

    runGeneralAudit() {
        return api
            .getJson(URL_GENERAL_AUDIT, {
                method: 'GET',
                credentials: 'include',
                disableBrowserCache: true,
                legacyStatus: true,
            })
            .then(response => response.value);
    }

    logout() {
        return api.getJson(URL_LOGOUT, { method: 'POST', credentials: 'include', cache: false });
    }

    setLanguage(code) {
        return api.getJson(URL_LANGUAGE, {
            method: 'POST',
            credentials: 'include',
            body: { language: code },
            cache: false,
        });
    }
}

export default TopbarService;
